export const URI_CUSTOM_TEMPLATE = 'custom/template';
export const URI_CUSTOM_TEMPLATE_DUPLICATE = `${URI_CUSTOM_TEMPLATE}/duplicate/private`;
